import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgColumnSolidComment = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "#cccccc", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M13.2 2H2.8C2.36 2 2 2.36 2 2.8V10C2 10.44 2.36 10.8 2.8 10.8H10.8L14 14V2.8C14 2.36 13.64 2 13.2 2Z", fill: "inherit" }) });
const ForwardRef = forwardRef(SvgColumnSolidComment);
export { ForwardRef as ReactComponent };
